<!--
// app/components/pages/region-tournament/LayoutTournamentKwcClubs.vue
-->
<script setup lang="ts">
import { setAliasUrl } from "~~/src/Shared/utils";
import KwcTeamsImageHome from "~/components/pages/region-home/KwcTeamsImageHome.vue";
import KwcTablesAllLeagues from "~/components/pages/region-world-cup/KwcTablesAllLeagues.vue";

const { $getLocale, $t } = useI18n();
const locale = $getLocale();

const video = computed(() => {
  return {
    es: "UmGo6b0uoDA?si=zp_ExjE8_WxwpvEz",
    en: "a7F9BPt1OhM?si=vciRJRtHbSW19etF",
    it: "e7gku9nxdGc?si=C78lkJobHUIw05gm",
    pt: "Q84UxEbHzdo?si=ZpMEpwIpGSgg5sUi",
    fr: "ZCN2jvArx6Y?si=Pz7OL0HN5che6h_-",
  };
});
</script>

<template>
  <section
    class="overflow-hidden md:mx-auto bg-[url('/img/world-cup/bg-tournament-v-kwc.jpg')] bg-cover bg-right-top min-h-[calc(100vh-20vh)]"
  >
    <div class="kql-w-container pt-10 bigsm:pt-20 bigsm:ps-20 bigsm:pe-0">
      <div class="block bigsm:flex bigsm:items-center bigsm:justify-between">
        <div class="px-6 bigsm:px-0 bigsm:w-1/2 bigsm:pe-10">
          <NuxtImg
            :src="setAliasUrl('/img/world-cup/kwc-clubs-no-shield.png')"
            alt="Kings World Cup"
            class="hidden bigsm:block w-[300px]"
            width="241"
            height="77"
          />
          <NuxtImg
            :src="setAliasUrl('/img/world-cup/KWC-clubs-horizontal.png')"
            alt="Kings World Cup"
            class="block bigsm:hidden w-full sm:w-1/2"
            width="312"
            height="120"
            sizes="272px sm:327px md:381px"
          />

          <p class="text-base bigsm:text-xl mb-5 mt-10" v-html="$t('worldCup.kwcc2026.text.p1')"></p>
          <p class="text-base bigsm:text-xl mb-5" v-html="$t('worldCup.kwcc2026.text.p2')"></p>
          <p class="text-base bigsm:text-xl mb-5" v-html="$t('worldCup.kwcc2026.text.p3')"></p>
          <p class="text-base bigsm:text-xl mb-5" v-html="$t('worldCup.kwcc2026.text.p4')"></p>
        </div>
        <div class="bigsm:w-1/2 flex items-center justify-center px-4 max-w-full">
          <iframe
            :key="locale"
            loading="lazy"
            width="310"
            height="auto"
            class="object-cover object-center max-w-full h-auto focus-visible:outline-none focus-visible:border-none rounded-lg w-[310px] aspect-[9/16] snap-start first:ms-4 first:md:ms-0 last:me-4 last:md:me-0"
            :src="`https://www.youtube-nocookie.com/embed/${video[locale] || video['en']}?rel=0`"
            title="KWCC Format"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowfullscreen
          ></iframe>
        </div>
      </div>
    </div>

    <div class="pt-8 md:pt-10">
      <div class="px-4">
        <kwc-teams-image-home just-image />
      </div>

      <h2 class="px-6 text-lg md:text-2xl font-['Termina'] font-bold mt-10 md:mt-16 text-center">
        Road to KWCC 2026
      </h2>
      <div class="flex justify-center mx-auto md:px-2">
        <kwc-tables-all-leagues is-home is-tournament />
      </div>
    </div>
  </section>
</template>

<style scoped></style>
